import {getPrivateAxios} from '../../libs';
import {UserEvent} from './types';

/**
 *
 * @returns
 */
export const fetchUserEventCreate = async (event: UserEvent) => {
  const {data} = await getPrivateAxios().post('/user-events', event);
  return data;
};
